import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PopupInfo {
  name: string;
  context: string;
  url?: string;
}

interface PopupContextType {
  currentPopup: PopupInfo | null;
  registerPopup: (popup: PopupInfo) => void;
  unregisterPopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const usePopupContext = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopupContext must be used within a PopupProvider');
  }
  return context;
};

interface PopupProviderProps {
  children: ReactNode;
}

export const PopupProvider: React.FC<PopupProviderProps> = ({ children }) => {
  const [currentPopup, setCurrentPopup] = useState<PopupInfo | null>(null);

  const registerPopup = (popup: PopupInfo) => {
    setCurrentPopup(popup);
  };

  const unregisterPopup = () => {
    setCurrentPopup(null);
  };

  return (
    <PopupContext.Provider value={{ currentPopup, registerPopup, unregisterPopup }}>
      {children}
    </PopupContext.Provider>
  );
};